export const close = (
  <svg width="16" height="16" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 0.5L6.5 6.5M0.5 6.5L6.5 0.5" stroke="white" strokeWidth="0.8px" />
  </svg>
);
